module.exports = __webpack_public_path__ + "static/media/PHP_API.8e9ad217.png";